/* jshint -W122 */
/**
 * Registers an AngularJS filter named 'encodeHtml' to encode HTML entities in a given text.
 * 
 * @param {object} module - The AngularJS module to which the filter will be registered.
 */
export default function registerEncodeHtmlFilter(module) {
    module.filter('encodeHtml', function() {
        /**
         * Encodes HTML entities in the provided text.
         * 
         * @param {string} text - The text to be encoded.
         * @param {boolean|string} includeHtmlTags - If true, HTML tags (<, >) will also be encoded. Defaults to false.
         * @returns {string} The encoded text.
         */
        return function (text, includeHtmlTags = false) {
            // Return the text as is if it is undefined
            if (typeof text === 'undefined')
                return text;

            // Convert includeHtmlTags to a boolean and default to false if not provided
            includeHtmlTags = Boolean(includeHtmlTags);

            // Define the regex pattern based on whether HTML tags should be included
            const regex = includeHtmlTags ? /[\x26\x0A\u003C\u003E'"]/g : /[\x26\x0A'"]/g;

            // Replace each matched character with its HTML entity
            return text.replace(regex, function(char){
                return "&#" + char.charCodeAt(0) + ";";
            });
        };
    });
}